import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchPost, objectify } from '../../utils';

export const fetch = async (query: { ProductId: number; Warehouse: string; filters: any; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { ProductId, Warehouse, filters, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchPost(
    `/InventoryEnquiry/Product/${ProductId}/Warehouse/${Warehouse}/Quantity/Reserved`,
    filters && {
      ReserveType: filters.ReserveType,
      CustomerId: filters.CustomerId
    },
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        StockingQuantityReserveds: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.StockingQuantityReserveds) {

            return {
              records: result.StockingQuantityReserveds.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
